import React, { useState, useEffect } from 'react';
import useAPI from '../../../../hooks/useAPI';
import useErrors from '../../../../hooks/useErrors';
import ComponentBusy from '../../../ComponentBusy';
import FormInput from '../../../FormInput';
import RoundedButton from '../../../RoundedButton';

const defaultQRCode = require('../../../../images/qr-code.png');

export default function AuthenticatorAuthSetup () {
    const [loading, setLoading] = useState(false);
    const [sendingSecret, setSendingSecret] = useState(false);
    const [qrCodeData, setQRCodeData] = useState('');
    const [secret, setSecret] = useState('');
    const [secretError, setSecretError] = useState('');
    const api = useAPI();
    const errors = useErrors();

    const generateQRCode = (force = 0)=>{
        setLoading(true);
        
        api.json('POST', '/account/two-factor-auth/generate-qr', {
                force,
            })
           .then(r => r.json())
           .then(r => {
                if(r.errors){
                    errors(r.errors);
                    return;
                }

                if(r.data){
                    setQRCodeData(r.data);
                }
           })
           .catch((e)=>{
                alert(e);
           })
           .then(()=>setLoading(false))
    }

    const sendSecret = () => {
        setSendingSecret(true);
        setSecretError('');

        api.json('POST', '/account/two-factor-auth/authenticator-setup', { secret })
            .then(r => r.json())
            .then(r => {
                if (r.errors) {
                    errors(r.errors);
                    return;
                }

                if (!r.success) {
                    setSecretError('Invalid code');
                    return;
                }

                const auth = api.cookie('auth');
                auth.two_factor_auth_enabled = true;
                auth.two_factor_auth_type = r.two_factor_auth_type;
                api.cookie('auth', auth);
                window.location.reload(true);
            })
            .catch((e) => {
                alert(e);
            })
            .finally(() => setSendingSecret(false));
    };

    useEffect(()=>{
        generateQRCode();
        // eslint-disable-next-line
    }, [])

    return (
        <div className='row' style={{ fontSize: 14 }}>
            <div className='col-12 col-md-8'>
                <h4 style={{ fontWeight: 600 }}>Instructions:</h4>
                <ol style={{ listStyleType: 'numbered', padding: '10px 15px', lineHeight: 1.4 }}>
                    <li>Download an authenticator app,<br />such as Google Authenticator for iOS or Android.</li>
                    <li>Add a new account by QR Code.</li>
                    <li>Scan QR Code.</li>
                    <li>Enter code from authenticator app.</li>
                </ol>
                {
                    qrCodeData ?
                        <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
                            <FormInput
                                value={secret}
                                disabled={sendingSecret || loading}
                                maxLength="6"
                                placeholder="Enter Code"
                                onChange={(e) => setSecret((e.target.value + '').replace(/[^0-9]+/g, ''))}
                                error={secretError}
                            />
                            <span>
                                <RoundedButton
                                    disabled={secret.length < 6 || sendingSecret}
                                    onClick={sendSecret}
                                >
                                    Submit Code
                                </RoundedButton>
                            </span>
                        </div>
                        : null
                }
            </div>
            <div className='col-12 col-md-4'>
                <div style={{ display: 'block', position: 'relative', width: 150, height: 150, margin: '0 auto 0 auto', overflow: 'hidden'}}>
                    <img src={qrCodeData ? ("data:image/svg+xml;base64," + qrCodeData) : defaultQRCode} alt="QR Code for Two-Factor Authentication" style={{ display: 'block', width: '100%', height: '100%', border: 'none', filter: !qrCodeData ? 'blur(3px)' : 'none'}}/>
                    {loading ?  <ComponentBusy/> : null}  
                </div>

                <div className='row'>
                    <div className='col-12'>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 12, textAlign: 'center', lineHeight: 1.2 }}>
                            {/* eslint-disable-next-line */}
                            <a href="#" onClick={(e)=>{
                                e.preventDefault();
                                generateQRCode(true);
                            }}>Having trouble?<br/>Regenerate code.</a>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    );
};